import isEmpty from "lodash-es/isEmpty"

import type { IEnrollmentDto, IEnrollmentModel } from "@/3514/types"

function enrollmentAdapter(dto: IEnrollmentDto): IEnrollmentModel {
    return isEmpty(dto)
        ? null
        : {
              firstPhaseStartDate: dto.first_phase_start,
              id: dto.id,
              lastPhaseEndDate: dto.last_phase_end,
              isModuleReflectionPassed: dto.module_reflection_passed,
              name: dto.name,
              rank: dto.rank,
              sessionTime: dto.related_session_time,
              sessionDuration: dto.related_session_duration,
              withPostModuleReflectionShown: dto.show_post_module_reflection,
              status: dto.status,
              versionId: dto.version_id,
              versionName: dto.version_name
          }
}

export { enrollmentAdapter }
